import React from 'react';
import { Chip } from '@material-ui/core';

import { estadoFactura, estadosEiffel, nombreEstado } from '../datosSmartScan';

/** Chip con el estado de revisión de la factura (Faltan datos, N pendientes, Lista para aprobar, Aprobada). */
export const EstadoFacturaChip = ({ factura, style }) => {
  const estado = estadoFactura(factura);
  return (
    <Chip
      size="small"
      label={nombreEstado(factura)}
      style={{ backgroundColor: estado.color, color: estado.textColor, fontWeight: 'bold', ...style }}
    />
  );
};

/** Chip con el estado de la grabación en Eiffel de una factura aprobada. */
export const EstadoEiffelChip = ({ eiffel, style }) => {
  const estado = eiffel && estadosEiffel[eiffel.estado];
  if (!estado) return null;
  return (
    <Chip
      size="small"
      label={estado.nombre}
      style={{ backgroundColor: estado.color, color: estado.textColor, fontWeight: 'bold', ...style }}
    />
  );
};
